import { PALETTE } from "../../constants/editor";

type PalettePickerProps = {
  color: string;
  onSelect: (color: string) => void;
  disabled?: boolean;
};

export function PalettePicker({ color, onSelect, disabled = false }: PalettePickerProps) {
  return (
    <>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 5 }}>
        {PALETTE.map((entry) => (
          <button
            key={entry}
            type="button"
            disabled={disabled}
            onClick={() => onSelect(entry)}
            aria-label={`Select ${entry}`}
            style={{
              width: "100%",
              aspectRatio: "1 / 1",
              borderRadius: 8,
              border: color === entry ? "2px solid #fff" : "2px solid transparent",
              background: entry,
              boxShadow: color === entry ? `0 0 10px ${entry}` : "none",
              opacity: disabled ? 0.5 : 1,
            }}
          />
        ))}
      </div>
      <div style={{ marginTop: 10, display: "flex", alignItems: "center", gap: 10 }}>
        <input disabled={disabled} type="color" value={color} onChange={(event) => onSelect(event.target.value)} style={{ width: 34, height: 26 }} />
        <div style={{ width: 20, height: 20, borderRadius: 6, background: color, boxShadow: `0 0 10px ${color}` }} />
        <div style={{ fontSize: 11, color: "#9ea3b5" }}>{color.toUpperCase()}</div>
      </div>
    </>
  );
}
